import { render } from "./permissions-create-edit.html?vue&type=template&id=9c2d52dc&scoped=true&ts=true"
import script from "./permissions-create-edit.ts?vue&type=script&lang=ts"
export * from "./permissions-create-edit.ts?vue&type=script&lang=ts"

import "./permissions-create-edit.scss?vue&type=style&index=0&id=9c2d52dc&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c2d52dc"]])

export default __exports__